import { createContext, useContext, type ReactNode } from "react";
import type { ApiClient } from "./client";
import type { Endpoints } from "./endpoints";
import type { DataMode } from "./mode";

export type ApiValue = { client: ApiClient; api: Endpoints; mode: DataMode };
const Ctx = createContext<ApiValue | null>(null);

export function ApiProvider({ value, children }: { value: ApiValue; children: ReactNode }) {
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useApi(): ApiValue {
  const v = useContext(Ctx);
  if (!v) throw new Error("useApi must be used inside <ApiProvider>");
  return v;
}
